import { Translations } from '@pegasus/translation';

import {
    myaccount as myaccountTranslations,
    header as headerTranslations,
    footer as footerTranslations,
    cart as cartTranslations,
    staticPages as staticPagesTranslations,
    contact,
} from './json/fr_CH.json';

export const messages = (_: any): Translations => {
    return {
        ...headerTranslations,
        ...footerTranslations,
        ...cartTranslations,
        ...myaccountTranslations,
        ...staticPagesTranslations,
        contact,
        locale: 'fr-CH',
    };
};
